declare global {
  interface Window {
    __SSS_CONFIG__?: {
      API_BASE_URL?: string;
      APP_NAME?: string;
      APP_TAGLINE?: string;
      LOGO_URL?: string;
      DEFAULT_LOCALE?: string;
      ACCENT_COLOR?: string;
      ACCENT_FG_COLOR?: string;
      SSO_ENABLED?: string;
      OTEL_BROWSER_EVENTS_ENABLED?: string;
      DEVELOPER_OPTIONS_DISABLED?: string;
    };
  }
}

export const API_BASE_URL: string =
  window.__SSS_CONFIG__?.API_BASE_URL ?? import.meta.env.VITE_API_BASE_URL ?? "http://localhost:3001";

export const APP_NAME: string = window.__SSS_CONFIG__?.APP_NAME || "SSS";
export const APP_TAGLINE: string = window.__SSS_CONFIG__?.APP_TAGLINE || "Share Sensitive Stuff";
export const LOGO_URL: string | undefined = window.__SSS_CONFIG__?.LOGO_URL || undefined;

/**
 * The language to fall back to when the reader has made no choice and their
 * browser asks for nothing we ship. Not a lock: a reader's own preference
 * still wins (`src/i18n`, `initialLocale`). Mirror the API's DEFAULT_LOCALE
 * so the pages and the emails they trigger speak the same language.
 */
export const DEFAULT_LOCALE: string | undefined = window.__SSS_CONFIG__?.DEFAULT_LOCALE || undefined;
export const ACCENT_COLOR: string | undefined = window.__SSS_CONFIG__?.ACCENT_COLOR || undefined;
export const ACCENT_FG_COLOR: string | undefined = window.__SSS_CONFIG__?.ACCENT_FG_COLOR || undefined;
export const SSO_ENABLED: boolean = window.__SSS_CONFIG__?.SSO_ENABLED === "true";

/**
 * Whether to report the handful of allowlisted retrieval outcomes in
 * lib/api.ts's reportBrowserEvent. Must mirror the API's own
 * OTEL_BROWSER_EVENTS_ENABLED, which is what actually accepts them.
 */
export const BROWSER_EVENTS_ENABLED: boolean =
  window.__SSS_CONFIG__?.OTEL_BROWSER_EVENTS_ENABLED === "true";

/**
 * Hides the create page's developer options (the per-secret webhook).
 * Mirror the API's DEVELOPER_OPTIONS_DISABLED, which is what actually
 * refuses a webhook; this only keeps the page from offering one.
 */
export const DEVELOPER_OPTIONS_DISABLED: boolean =
  window.__SSS_CONFIG__?.DEVELOPER_OPTIONS_DISABLED === "true";

// Applied here (not a React effect) so branding is in place before first
// paint — config.js is loaded synchronously ahead of the app bundle.
document.title = `${APP_NAME} — ${APP_TAGLINE}`;
if (ACCENT_COLOR) document.documentElement.style.setProperty("--accent", ACCENT_COLOR);
if (ACCENT_FG_COLOR) document.documentElement.style.setProperty("--accent-fg", ACCENT_FG_COLOR);
